import {useCallback, useEffect, useState}from 'react'
import CollapsablePanel from '../../common/collapsable-panel/collapsable-panel';
import { AddIcon, DeleteIcon } from '../../common/icons';
import PositionInformation from './position-information/position-information';
import HomePositionIndividual from './home-position-individual/home-position-individual';
import NonHomePositionIndividual from './non-home-position-individual/non-home-position-individual';
import { IPosition } from '../../../types/position';
import { useLazyQuery, useMutation } from '@apollo/client';
import { EXPIRE_POSITION_ROLE, GET_ORG_POSITIONS, GET_ORG_ROLES, GET_POSITION_DETAIL } from '../../../graphql/position-gql';
import useToggle from '../../../hook/useToggle';
import AssignIndividualModal from './assign-individual/assign-individual';
import { notifyError, notifySuccess } from '../../../services/notification';
import useAuth from '../../../hook/useAuth';
import SpinnerOverlay from '../../common/spinner/spinner';
import Button from '../../common/button';

type PositionDetailProps = {

    position: IPosition;
    updateSelectedPosition?:(updatedPosition:IPosition)=>void
    onExpirePosition?: () => void
}

const PositionDetails = (props: PositionDetailProps) => {
    const {position,updateSelectedPosition,onExpirePosition} = props
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false)
    const toggleDropdownOpen = useCallback(() => {setDropdownOpen(!dropdownOpen)}, [dropdownOpen])
    const { isOpen : isAssignOpen, toggle : assignToggle } = useToggle()
    const [expirable,setExpirable] = useState<boolean>(false);
    const [getPositionDetail,{loading:positionLoading, data:positionDetailData }]= useLazyQuery(GET_POSITION_DETAIL);
    const [ expirePositionOrRole ] = useMutation(EXPIRE_POSITION_ROLE);
    const { isAdmin, isCoordinator, isFrenchTranslator } = useAuth();
    const [cloned,setCloned] = useState<boolean>(false);

    useEffect(()=>{
        setCloned(!!position?.shareLinkId)
    },[position])

    useEffect(()=>{
        setExpirable(!position?.individuals)
        //console.log("position:",position)
        getPositionDetail({variables:{positionId:position.positionId},fetchPolicy: "network-only"});
    },[position,getPositionDetail])

    useEffect(()=>{
        //console.log("positionDetailData:",positionDetailData)

    },[positionDetailData])

    const getRefetchQuery = () => {
        if(position?.isRole)
            return [{query: GET_ORG_ROLES, variables: {  orgId: positionDetailData?.position.orgId } }]
        else
            return [{query: GET_ORG_POSITIONS, variables: {  orgId: positionDetailData?.position.orgId } }]
    }
    const onExpirePositionOrRoleHandle = ()=>{
        expirePositionOrRole({variables: {
            orgId:position.orgId,
            positionIds: [position.positionId]
        },
        refetchQueries: getRefetchQuery(),
        awaitRefetchQueries: true,
        onCompleted: (data) => {
            if(data?.expirePositionOrRole?.success) {
                onExpirePosition && onExpirePosition()
                notifySuccess()
            }else if(data?.expirePositionOrRole?.message) notifyError(data.expirePositionOrRole.message)
        }})
    }
    
    return (
        <div>
            {( positionLoading ) && <SpinnerOverlay/>}
            {
                positionDetailData?.position&&<AssignIndividualModal position={positionDetailData.position} isOpen={isAssignOpen} toggle={assignToggle}/>
            }
            <div className="py-3">
                {(isAdmin || isCoordinator) && <Button color="primary" style={{ marginRight: '15px' }} onClick={assignToggle} disabled={cloned}>
                    <AddIcon />
                    &nbsp;Assign
                </Button>
                }
               {/*(isAdmin || isCoordinator) && <Button color="danger" style={{ marginRight: '15px' }} onClick={onExpirePositionOrRoleHandle} disabled={!expirable}>
                    <DeleteIcon/>
                    &nbsp;Expire Position
                </Button>
              */}
            </div>
            
            {(positionDetailData?.position ) &&
            <>
            <CollapsablePanel headTitle="Position Information" initCollapse={false} helpUrl="">
                <PositionInformation position={positionDetailData?.position} updateSelectedPosition={updateSelectedPosition} />
            </CollapsablePanel>
            <br />
            <CollapsablePanel headTitle="Home Position Individual" initCollapse={false} helpUrl="">
                <HomePositionIndividual position={positionDetailData?.position} />
            </CollapsablePanel>
            <br /> 
            <CollapsablePanel headTitle="Non-Home Position Individual" initCollapse={false} helpUrl="">
                <NonHomePositionIndividual position={positionDetailData?.position}/>
            </CollapsablePanel>
            <br />         
            {/*<CollapsablePanel headTitle="Relationship to Other Organizations" initCollapse={false} helpUrl="">
                <PositionRelationship position={positionDetailData?.position}/>
            </CollapsablePanel>*/}
            </>}

        </div>
    )
}

export default PositionDetails;